export default "__VITE_ASSET__BmyWgh7X__"